module.exports = __webpack_public_path__ + "static/img/c.34ec3fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/c.png
// module id = I+sx
// module chunks = 1